import { useContext, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/esm/Modal';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import { distanceInKmBetweenEarthCoordinates } from '../utils';
import AskAddressAndApproveOrderModal from './AskAddressModal';
import AskCustomerNameAndApproveOrderModal from './AskNameModal';
import CustomerCart from './CustomerCart';

export default function CustomerCartModal(props) {
  const {
    businessName,
    code,
    cartShow,
    setCartShow,
    table,
    setScanBarcode,
    tableCodeExist,
    carts,
    approveOrder,
    tableCode,
    customerName,
    setCustomerName,
    latitude,
    longitude,
    isWaitress,
  } = props;
  const [enterNameShow, setEnterNameShow] = useState(false);
  const [enterAddressShow, setEnterAddressShow] = useState(false);
  const navigate = useNavigate();
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [gerror, setGerror] = useState(false);

  const { state } = useContext(Store);
  const { userInfo } = state;

  const getGeoPosition = (karekod) => {
    navigator.geolocation.getCurrentPosition(
      (p) => {
        setLat(p.coords.latitude);
        setLng(p.coords.longitude);
        karekod(latitude, longitude, p.coords.latitude, p.coords.longitude);
      },
      (e) => {
        setGerror(true);

        navigator.permissions.query({ name: 'geolocation' }).then((result) => {
          if (result.state === 'granted') {
            window.alert(
              'Konum servisiniz kapalı! Lütfen öncelikle cihaz ayarlarından konum servisini açınız!'
            );
          } else if (result.state === 'prompt') {
          } else if (result.state === 'denied') {
            window.alert(
              'Uygulamanın konum servisine erişimi kısıtlandı! Bu işlemi gerçekleştiremezsiniz!'
            );
          }
        });
      }
    );
  };

  return (
    <>
      <Modal show={cartShow} onHide={() => setCartShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-shopping-cart"></i>&nbsp;Sepetim
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomerCart
            customerName={customerName}
            tableNum={table}
          ></CustomerCart>
        </Modal.Body>
        <Modal.Footer>
          {tableCodeExist && table ? (
            carts[table - 1].cartItems.filter((i) => !i.tableCode).length >
            0 ? (
              <Button
                variant="primary"
                onClick={() => {
                  if (isWaitress) {
                    setEnterNameShow(true);
                    setCartShow(false);
                  } else {
                    if (customerName && userInfo && userInfo.isUser) {
                      setEnterAddressShow(true);
                      setCartShow(false);
                    } else if (!customerName) {
                      setEnterNameShow(true);
                      setCartShow(false);
                    } else if (customerName) {
                      approveOrder(tableCode, customerName);
                    }
                  }
                }}
              >
                Siparişi Onayla
              </Button>
            ) : null
          ) : (
            <>
              <Button
                variant="link"
                className="textDecorationNone"
                onClick={() => {
                  navigate(
                    `/customer_signin?code=${code}&redirect=${encodeURIComponent(
                      '/qrmenu?code=' + code + '&afterSignIn=true'
                    )}`
                  );
                }}
              >
                Giriş Yap&nbsp;
                <i className="fas fa-user"></i>
              </Button>
              <span className="text-danger">veya</span>
              <Button
                variant="primary"
                onClick={() => {
                  if (
                    !window.confirm(
                      'Lütfen uygulamanın google konum servini kullanmasına izin veriniz!'
                    )
                  ) {
                    return;
                  }
                  if (!navigator.geolocation) {
                    window.alert(
                      'Cihazınız konum servisini desteklememektedir, lüften bu işlemi konum hizmeti çalışan bir cihazdan gerçekleştiriniz!'
                    );
                  } else {
                    if (!latitude || !longitude) {
                      toast.error('İşletmenin konum bilgisine ulaşılamdı!');
                      return;
                    }
                    getGeoPosition((latitude, longitude, lat, lng) => {
                      if (
                        distanceInKmBetweenEarthCoordinates(
                          latitude,
                          longitude,
                          lat,
                          lng
                        ) *
                          1000 >
                        30
                      ) {
                        toast.error(
                          'Bu işlemi yalnızca ' +
                            businessName +
                            "'den gerçekleştirebilirsiniz!"
                        );
                        return;
                      }
                      setScanBarcode(true);
                    });
                  }
                }}
              >
                Karekod&nbsp;
                <i className="fas fa-camera"></i>
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <AskCustomerNameAndApproveOrderModal
        enterNameShow={enterNameShow}
        setEnterNameShow={setEnterNameShow}
        customerName={customerName}
        setCustomerName={setCustomerName}
        approveOrder={approveOrder}
        tableCode={tableCode}
      ></AskCustomerNameAndApproveOrderModal>
      <AskAddressAndApproveOrderModal
        enterAddressShow={enterAddressShow}
        setEnterAddressShow={setEnterAddressShow}
        customerName={customerName}
        setCustomerName={setCustomerName}
        approveOrder={approveOrder}
        tableCode={tableCode}
      ></AskAddressAndApproveOrderModal>
    </>
  );
}
